import { Icon, Text } from '@joor/design-system'
import classNames from 'classnames'
import { useSelector } from 'react-redux'

import { formatDate } from 'utils/dates'
import { formatConnectedAccounts } from 'utils/formatters'

import { getDateFormat } from 'store/currentUser/selectors'

import {
  CreationInfoContainer,
  Info,
  MenuConnectedAccounts,
  MenuTextMessage,
  MenuTextMessageCheck,
  PrimaryWrapper,
  PrivacyWrapper,
  TextIconsWrapper,
} from './AccountInfo.ui'
import { ConnectedAccountType } from 'features/Navbar/NavbarLiteRetailer/NavbarLiteRetailer.queries'

export interface AccountInfoType {
  accountName: string
  connectedAccounts?: ConnectedAccountType[]
  showCheckMarkIcon?: boolean
  privacy: boolean
  createdAt: string
  isPrimary: boolean
  hideVisibilityIcon?: boolean
  createdBy?: string | null
  disabled?: boolean
}

export const AccountInfo = ({
  accountName,
  connectedAccounts = [],
  showCheckMarkIcon = false,
  isPrimary,
  createdAt,
  privacy,
  hideVisibilityIcon = false,
  createdBy,
  disabled = false,
}: AccountInfoType) => {
  const textClassName = disabled
    ? 'disabled'
    : showCheckMarkIcon
      ? 'checked'
      : ''
  const userDateFormat = useSelector(getDateFormat)?.toUpperCase()
  const formattedDate = formatDate(createdAt, userDateFormat)

  return (
    <>
      {isPrimary && (
        <PrimaryWrapper>
          <Icon
            iconName="pushpin"
            plain
            iconSize="small"
            className={disabled ? 'primary-icon' : 'accent-icon'}
          />
          <Text
            fontFamily="numeric"
            fontSize="extrasmall"
            color={disabled ? 'primary-400' : 'accent-beta-700'}
          >
            PRIMARY
          </Text>
        </PrimaryWrapper>
      )}
      <TextIconsWrapper>
        <PrivacyWrapper>
          <MenuTextMessage className={classNames(textClassName, 'notranslate')}>
            {accountName}
          </MenuTextMessage>
        </PrivacyWrapper>
        <MenuTextMessageCheck className={textClassName}>
          {!hideVisibilityIcon && (
            <Icon
              iconName={privacy ? 'visibility-on' : 'visibility-off'}
              iconSize="small"
              plain
            />
          )}
          {showCheckMarkIcon && <Icon iconName="checkmark" plain />}
        </MenuTextMessageCheck>
      </TextIconsWrapper>
      {!!connectedAccounts.length && (
        <MenuConnectedAccounts className={disabled ? 'disabled' : ''}>
          {formatConnectedAccounts(connectedAccounts)}
        </MenuConnectedAccounts>
      )}
      {(createdBy || createdAt) && (
        <CreationInfoContainer className={Boolean(createdBy) ? 'spaced' : ''}>
          {createdBy && (
            <Info className={disabled ? 'disabled' : ''}>
              Created by {createdBy}
            </Info>
          )}
          <Info className={disabled ? 'disabled' : ''}>
            {!createdBy && 'Created date:'} {formattedDate}
          </Info>
        </CreationInfoContainer>
      )}
    </>
  )
}
